export default __webpack_public_path__ + "static/media/mylogo.050f4f5c.png";